webpackJsonp([261200455461845],{

/***/ 1835:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LegalEntity","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"vertexCode","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-legal-entity-fb2a364fb26c9b78237b.js